import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-analise-pagamento-pdf',
  templateUrl: './analise-pagamento-pdf.component.html',
  styleUrls: ['./analise-pagamento-pdf.component.css']
})
export class AnalisePagamentoPdfComponent implements AfterViewInit{

  headerImagePDF:any;
  footerImagePDF:any;

  @ViewChild('contentPrint', { static: false }) el!: ElementRef;
  @Input() paymentAnalyze: any;
  
  constructor(public activeModal: NgbActiveModal) { }

  generatePDF() {
    const doc = new jsPDF('p', 'mm', 'a4');
    const sections = ['section1', 'section2', 'section3'];
    let currentPage = 1;
  
    const captureElementAsImage = async (elementId: string): Promise<string> => {
      const element = document.getElementById(elementId);
      if (element) {
        const canvas = await html2canvas(element, { scale: 2 });
        return canvas.toDataURL('image/png', 0.8);
      }
      return '';
    };
  
    const addHeaderAndFooter = (pageNum: number, pageCount: number) => {
      if (this.headerImagePDF) {
        doc.addImage(this.headerImagePDF, 'PNG', 10, 10, 190, 30);
      }
      if (this.footerImagePDF) {
        doc.addImage(this.footerImagePDF, 'PNG', 10, doc.internal.pageSize.height - 20, 190, 15);
      }
      doc.setFontSize(6);
      doc.setTextColor('#929292');
      doc.text(`Página ${pageNum} de ${pageCount}`, 10, doc.internal.pageSize.height - 5);
    };
  
    const generateContent = async () => {
      [this.headerImagePDF, this.footerImagePDF] = await Promise.all([
        captureElementAsImage('header'),
        captureElementAsImage('footer')
      ]);
  
      for (let i = 0; i < sections.length; i++) {
        const sectionId = sections[i];
        const sectionElement = document.getElementById(sectionId);
  
        if (sectionElement) {
          const canvas = await html2canvas(sectionElement, { scale: 2 });
          const imgData = canvas.toDataURL('image/png');
          const imgWidth = 190;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
          if (i > 0) doc.addPage();
          addHeaderAndFooter(currentPage, sections.length);
          doc.addImage(imgData, 'PNG', 10, 50, imgWidth, imgHeight);
          currentPage++;
        }
      }
      
      doc.save(`AnalisePagamento-${this.paymentAnalyze.paymentDate.split('T')[0]}.pdf`);
      this.activeModal.close();
    };
  
    generateContent();
  }
  

    //  generatePDF() {
    //    const doc = new jsPDF('p', 'mm', 'a4');
    //    const headerElement = document.getElementById('header');
    //    const sections = ['section1', 'section2', 'section3'];
    //    let currentPage = 1;

    //    if (headerElement) {
    //     html2canvas(headerElement, {scale: 2}).then(canvas => {
    //       const headerImage = canvas.toDataURL('image/jpeg', 0.8);
    //       setTimeout( ()=>{            
    //       }, 5000)})
    //       }
  

    //    const captureElementAsImage = (elementId: string): Promise<string> => {
    //     const element = document.getElementById(elementId);
    //     if (element) {
    //       return html2canvas(element, {scale: 2}).then(canvas => canvas.toDataURL('image/png', 0.8));
    //     }
    //     return Promise.resolve('');
    //   };

    //   Promise.all([
    //     captureElementAsImage('header'),
    //     captureElementAsImage('footer')
    //   ]).then(([headerImage, footerImage]) => {      

    //     this.headerImagePDF = headerImage;
    //     this.footerImagePDF = footerImage;
    //   });


  
    //    const addHeaderAndFooter = (pageNum: number, pageCount: number) => {
        
    //     // doc.setFontSize(8);
    //     // doc.text(`Cabeçalho`, 10, 10);
    //     doc.addImage(this.headerImagePDF, 'PNG', 10, 10, 190, 30);
    //     //  doc.addImage( document.getElementById('header'), 'PNG', 10, 10, 190,15 );

    //     doc.addImage(this.footerImagePDF, 'PNG', 10, (doc.internal.pageSize.height - 20), 190, 15);
    //     doc.setFontSize(6);
    //     doc.setTextColor('#929292');        
    //     doc.text(`Página ${pageNum} de ${pageCount}`, 2, doc.internal.pageSize.height - 2);
    //    };       
  
    //    setTimeout( ()=>{

    //     const captureSection = (index: number) => {
    //       if (index >= sections.length) {
    //         doc.save(`AnalisePagamento-${this.paymentAnalyze.paymentDate.split('T')[0]}.pdf`);
    //         return;
    //       }
    //       const sectionId = sections[index];
    //       const sectionElement = document.getElementById(sectionId);
    //       if (sectionElement) {
    //         html2canvas(sectionElement, {scale: 2}).then(canvas => {
    //           const imgData = canvas.toDataURL('image/png');
    //           const imgWidth = 190; 
    //           const pageHeight = doc.internal.pageSize.height;
    //           const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //           if (index > 0) doc.addPage(); 
    //           addHeaderAndFooter(currentPage, sections.length); 
    //           doc.addImage(imgData, 'PNG', 10, 50, imgWidth, imgHeight); 
 
    //           currentPage++;
    //           captureSection(index + 1); 
    //         });
    //       }
    //     };
    //     captureSection(0);
        
    //     setTimeout( ()=>{
    //       this.activeModal.close();
    //     },200 )
        
    //    }, 10000 )
    //  }

    ngAfterViewInit(): void {
      this.generatePDF();
    }

  ngOnInit() {    
    // this.generatePDF();

  }

}
